export const API_BASE =
  process.env.REACT_APP_API_URL ?? "http://localhost:8080/api/v1";

/**
 * Public SPA origin for share links (certificate verify page). Baked at build from REACT_APP_PUBLIC_APP_URL.
 * Falls back to window.location.origin when unset (e.g. local dev).
 */
export function getPublicAppOrigin() {
  const env = (process.env.REACT_APP_PUBLIC_APP_URL || "").trim().replace(/\/+$/, "");
  if (env) return env;
  if (typeof window !== "undefined") return window.location.origin;
  return "";
}

/** Bank transfer instructions for pemohon registration fee (display only; verify amounts with finance). */
export const PAYMENT_BANK_NAME = "BCA SYARIAH";
export const PAYMENT_ACCOUNT_NUMBER = "0448710111";
export const PAYMENT_ACCOUNT_HOLDER = "PT HALAL DIGITAL INTERNASIONAL";
/** @deprecated Prefer total from GET /packages + selected packages in UI. */
export const PAYMENT_AMOUNT = "Rp 2.500.000";

export const STEPS = [
  { id: 1, name: "Pre-Asesmen", sub: "Pengajuan Dokumen" },
  { id: 2, name: "Asesmen", sub: "Verifikasi Kelengkapan" },
  { id: 3, name: "Evaluasi", sub: "Penilaian LPH" },
];
